import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
// Copyright 2017-2022 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { BigInt } from '@polkadot/x-bigint';
import { _1n } from "../bi/consts.js";
import { objectSpread } from "../object/spread.js";
var U8_MAX = BigInt(256);
var U16_MAX = BigInt(256 * 256);

function xor(input) {
  var result = new Uint8Array(input.length);
  var dvI = new DataView(input.buffer, input.byteOffset);
  var dvO = new DataView(result.buffer);
  var mod = input.length % 2;
  var length = input.length - mod;

  for (var i = 0; i < length; i += 2) {
    dvO.setUint16(i, dvI.getUint16(i) ^ 0xffff);
  }

  if (mod) {
    dvO.setUint8(length, dvI.getUint8(length) ^ 0xff);
  }

  return result;
}

function toBigInt(input) {
  var dvI = new DataView(input.buffer, input.byteOffset);
  var mod = input.length % 2;
  var length = input.length - mod;
  var result = BigInt(0);

  for (var i = 0; i < length; i += 2) {
    result = result * U16_MAX + BigInt(dvI.getUint16(i));
  }

  if (mod) {
    result = result * U8_MAX + BigInt(dvI.getUint8(length));
  }

  return result;
}
/**
 * @name u8aToBigInt
 * @summary Creates a BigInt from a Uint8Array object.
 */


export function u8aToBigInt(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!value || !value.length) {
    return BigInt(0);
  }

  var _objectSpread = objectSpread({
    isLe: true,
    isNegative: false
  }, options),
      isLe = _objectSpread.isLe,
      isNegative = _objectSpread.isNegative;

  var u8a = isLe ? value.reverse() : value;
  return isNegative ? toBigInt(xor(u8a)) * -_1n - _1n : toBigInt(u8a);
}